/* NIGHTMARKET code-drawn background. Settings come from Theme settings > Background. */
(function () {
  'use strict';
  var host = document.getElementById('NMBackground');
  if (!host) return;
  var root = document.documentElement;
  var cfg = {
    style: host.getAttribute('data-style'),
    strength: { quiet: 0.35, medium: 0.62, full: 1 }[host.getAttribute('data-strength')] || 0.35,
    behind: host.getAttribute('data-behind'),
    seed: +host.getAttribute('data-seed') || 7,
    grain: (+host.getAttribute('data-grain') || 0) / 100,
    drift: host.getAttribute('data-drift') === 'true',
    mask: host.getAttribute('data-mask'),
    maskJs: host.getAttribute('data-mask-js'),
    inkFont: host.getAttribute('data-ink-font')
  };
  var fixedC = host.querySelector('.bg__fixed');
  var heroC = host.querySelector('.bg__hero');
  var STAR = 'M50 5.3C52.47 45.87 58.34 47.54 97 50C58.34 52.46 52.47 54.13 50 94.7C47.53 54.13 41.66 52.46 3 50C41.66 47.54 47.53 45.87 50 5.3Z';
  var starPath = window.Path2D ? new Path2D(STAR) : null;

  /* ---------- noise ---------- */
  function hash(x, y, s) { var h = (x * 374761393 + y * 668265263 + s * 1442695041) | 0; h = Math.imul(h ^ (h >>> 13), 1274126177); h ^= h >>> 16; return (h >>> 0) / 4294967295; }
  function vnoise(x, y, s) {
    var xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi, u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf);
    var a = hash(xi, yi, s), b = hash(xi + 1, yi, s), c = hash(xi, yi + 1, s), d = hash(xi + 1, yi + 1, s);
    return a + (b - a) * u + (c - a) * v + (a - b - c + d) * u * v;
  }
  function fbm(x, y, s) { var t = 0, a = 0.5, f = 1; for (var i = 0; i < 4; i++) { t += a * vnoise(x * f, y * f, s + i * 17); f *= 2; a *= 0.5; } return t / 0.9375; }
  function sstep(a, b, x) { var t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); }
  function mk(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; var x = c.getContext('2d', { willReadFrequently: true }); x.fillStyle = '#000'; x.fillRect(0, 0, w, h); return x; }
  function lum(x, w, h) { var d = x.getImageData(0, 0, w, h).data, f = new Float32Array(w * h); for (var i = 0; i < w * h; i++) f[i] = d[i * 4] / 255; return f; }
  function drawStar(x, cx, cy, size, rot) { if (!starPath) return; x.save(); x.translate(cx, cy); x.rotate(rot || 0); var k = size / 94; x.scale(k, k); x.translate(-50, -50); x.fill(starPath); x.restore(); }

  var tiger = null, tigerReady = false;
  function needsTiger(style) { return style === 'tiger' || style === 'haze'; }
  function loadTiger(src) {
    tiger = new Image();
    tiger.onload = function () { tigerReady = true; cache = {}; paint(); };
    tiger.src = src;
  }
  if (needsTiger(cfg.style)) {
    // a data URL is same-origin everywhere, so reading its pixels is never blocked
    if (window.NMTigerMask) loadTiger(window.NMTigerMask);
    else if (cfg.maskJs) {
      var sc = document.createElement('script'); sc.src = cfg.maskJs; sc.async = true;
      sc.onload = function () { if (window.NMTigerMask) loadTiger(window.NMTigerMask); };
      document.head.appendChild(sc);
    }
  }
  var inkReady = cfg.style !== 'ink';
  if (cfg.style === 'ink' && window.FontFace) {
    var ff = new FontFace('NM Ink', 'url(' + cfg.inkFont + ')');
    ff.load().then(function (f) { document.fonts.add(f); inkReady = true; cache = {}; paint(); }).catch(function () { inkReady = true; paint(); });
  }

  /* ---------- generators: each returns a 0..1 field ---------- */
  var G = {
    tiger: { lw: 360, invertDay: true, field: function (w, h, s) {
      if (!tigerReady) return new Float32Array(w * h).fill(0.05);
      var x = mk(w, h), iw = tiger.naturalWidth, ih = tiger.naturalHeight, sc, cx, cy;
      if (w >= h) { sc = h * 1.14 / ih; cx = w * (0.5 + (hash(4, 1, s) - 0.5) * 0.18); cy = h * (0.5 + (hash(4, 5, s) - 0.5) * 0.08); }
      else { sc = h * 0.95 / ih; var f = hash(4, 2, s) < 0.5 ? 0.3 : 0.69; cx = w / 2 - (f - 0.5) * iw * sc; cy = h * 0.52; }
      var rot = (hash(4, 3, s) - 0.5) * 0.12;
      x.save(); x.translate(cx, cy); x.rotate(rot); x.filter = 'blur(0.6px)'; x.drawImage(tiger, -iw * sc / 2, -ih * sc / 2, iw * sc, ih * sc);
      x.globalAlpha = 0.2; var k = 1.05; x.drawImage(tiger, -iw * sc * k / 2 + w * 0.022, -ih * sc * k / 2 - h * 0.016, iw * sc * k, ih * sc * k); x.restore();
      var m = lum(x, w, h); for (var i = 0; i < w * h; i++) { var px = i % w, py = (i / w) | 0; m[i] = 0.05 + 0.92 * Math.min(1, m[i] * 2.3) + 0.07 * (fbm(px / w * 5, py / h * 5, s) - 0.5); } return m;
    } },
    haze: { lw: 140, invertDay: true, field: function (w, h, s) {
      if (!tigerReady) return new Float32Array(w * h).fill(0.05);
      var x = mk(w, h), iw = tiger.naturalWidth, ih = tiger.naturalHeight, sc = Math.max(h * 1.5 / ih, w * 1.15 / iw);
      var cx = w * (0.5 + (hash(8, 1, s) - 0.5) * 0.3), cy = h * (0.48 + (hash(8, 2, s) - 0.5) * 0.2);
      x.filter = 'blur(' + Math.max(3, w / 36) + 'px)'; x.drawImage(tiger, cx - iw * sc / 2, cy - ih * sc / 2, iw * sc, ih * sc); x.filter = 'none';
      var m = lum(x, w, h); for (var i = 0; i < w * h; i++) m[i] = 0.05 + 0.5 * Math.min(1, m[i] * 3.4); return m;
    } },
    star: { lw: 240, field: function (w, h, s) {
      var x = mk(w, h), cx = w * (0.58 + hash(1, 2, s) * 0.16), cy = h * (0.42 + hash(3, 4, s) * 0.14), r0 = (hash(5, 6, s) - 0.5) * 0.5;
      for (var i = 0; i < 8; i++) {
        var size = h * 2.5 * Math.pow(0.74, i), g = x.createRadialGradient(cx, cy, 0, cx, cy, size * 0.5), c = 200 - i * 8;
        g.addColorStop(0, 'rgb(22,22,22)'); g.addColorStop(0.55, 'rgb(70,70,70)'); g.addColorStop(1, 'rgb(' + c + ',' + c + ',' + c + ')');
        x.fillStyle = g; x.filter = 'blur(' + (1.4 - i * 0.12) + 'px)'; drawStar(x, cx, cy, size, r0 + i * 0.07);
      }
      x.filter = 'none'; var f = lum(x, w, h);
      for (var j = 0; j < w * h; j++) { var px = j % w, py = (j / w) | 0; f[j] = 0.06 + 0.82 * f[j] + 0.08 * (fbm(px / w * 6, py / h * 6, s + 3) - 0.5); } return f;
    } },
    ink: { lw: 300, field: function (w, h, s) {
      var x = mk(w, h), fs = h * 1.35; x.font = fs + 'px "NM Ink", "Kaiti TC", "STKaiti", serif'; x.textBaseline = 'middle'; x.fillStyle = '#fff';
      var ox = w * (0.02 + hash(2, 9, s) * 0.1); x.filter = 'blur(1.5px)'; x.globalAlpha = 0.9; x.fillText('夜市', ox, h * 0.55);
      x.globalAlpha = 0.28; x.fillText('夜市', ox + w * 0.035, h * 0.5); x.filter = 'none';
      var f = lum(x, w, h); for (var i = 0; i < w * h; i++) { var px = i % w, py = (i / w) | 0; f[i] = 0.08 + 0.66 * f[i] + 0.12 * fbm(px / w * 5, py / h * 5, s); } return f;
    } },
    lantern: { lw: 220, field: function (w, h, s) {
      var L = [], k, i;
      for (k = 0; k < 3; k++) {
        var y0 = h * (0.16 + k * 0.22 + hash(k, 1, s) * 0.08), sag = h * (0.1 + hash(k, 2, s) * 0.1), n = 7 + k * 3, rad = h * (0.16 - k * 0.04);
        for (i = 0; i < n; i++) { var t = (i + 0.5 + (hash(i, k, s) - 0.5) * 0.5) / n; L.push([t * w * 1.1 - w * 0.05, y0 + sag * (1 - Math.pow(2 * t - 1, 2)), rad * (0.75 + hash(i, k + 5, s) * 0.5), 0.35 + hash(i, k + 9, s) * 0.45]); }
      }
      var f = new Float32Array(w * h);
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
        var v = 0.06 + 0.08 * (1 - y / h) + 0.06 * fbm(x / w * 4, y / h * 4, s);
        for (i = 0; i < L.length; i++) { var l = L[i], d = Math.hypot(x - l[0], y - l[1]), r = l[2]; if (d < r * 1.1) v += l[3] * (0.55 * sstep(r, r * 0.82, d) + 0.25 * sstep(r * 0.8, r * 0.96, d) * sstep(r * 1.05, r * 0.96, d)); }
        f[y * w + x] = Math.min(1, v);
      }
      return f;
    } },
    dither: { lw: 160, pixel: true, field: function (w, h, s) {
      var sx = mk(w, h); sx.fillStyle = '#fff'; for (var i = 0; i < 10; i++) drawStar(sx, hash(i, 3, s) * w, hash(i, 4, s) * h, 5 + hash(i, 5, s) * 12, 0);
      var st = lum(sx, w, h), f = new Float32Array(w * h), mx = w * (0.68 + hash(1, 1, s) * 0.12), my = h * (0.34 + hash(2, 2, s) * 0.1), R = h * 0.24;
      var B = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
        var d1 = Math.hypot(x - mx, y - my), d2 = Math.hypot(x - mx - R * 0.42, y - my + R * 0.22);
        var cres = sstep(R, R - 1.2, d1) * sstep(R * 0.86, R * 0.86 + 1.2, d2);
        var v = 0.04 + 0.14 * (y / h) + 0.32 * Math.exp(-d1 / (h * 0.42)) + 0.75 * cres + 0.9 * st[y * w + x] + 0.05 * (fbm(x / w * 5, y / h * 5, s) - 0.5);
        f[y * w + x] = v > (B[(y & 3) * 4 + (x & 3)] + 0.5) / 16 ? 1 : 0;
      }
      return f;
    } },
    silk: { lw: 220, field: function (w, h, s) {
      var f = new Float32Array(w * h);
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
        var u = x / h * 1.3, v = y / h * 1.3, q = fbm(u, v, s), r = fbm(u + 2.6 * q + 1.7, v + 2.6 * q + 9.2, s + 5), g = fbm(u + 2.8 * r, v + 2.8 * r, s + 11);
        var band = 0.5 + 0.5 * Math.sin(g * 11 + u * 1.6); f[y * w + x] = 0.08 + 0.78 * Math.pow(band, 1.6) * (0.55 + 0.45 * g);
      }
      return f;
    } },
    flat: { lw: 64, field: function (w, h, s) { var f = new Float32Array(w * h); for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) f[y * w + x] = 0.05 + 0.05 * fbm(x / w * 2, y / h * 2, s); return f; } },
    glow: { lw: 96, field: function (w, h, s) {
      var f = new Float32Array(w * h), cx = w * (0.5 + (hash(7, 1, s) - 0.5) * 0.3);
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) { var dx = (x - cx) / (w * 0.6), dy = (y + h * 0.2) / (h * 0.7); f[y * w + x] = 0.04 + 0.42 * Math.exp(-(dx * dx + dy * dy)) + 0.03 * fbm(x / w * 3, y / h * 3, s); }
      return f;
    } },
    concrete: { lw: 64, pal: { night: [[22, 21, 20], [44, 43, 40]], day: [[120, 118, 113], [146, 144, 139]] }, field: function (w, h, s) {
      var f = new Float32Array(w * h); for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) f[y * w + x] = 0.5 + 0.5 * (fbm(x / w * 3, y / h * 3, s) - 0.5); return f;
    } }
  };

  /* ---------- colors: matched to the theme's own background ---------- */
  function rgb(str) {
    var c = document.createElement('canvas').getContext('2d'); c.fillStyle = '#000'; c.fillStyle = (str || '').trim() || '#000';
    var h = c.fillStyle; if (h.charAt(0) === '#') return [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)];
    var m = h.match(/\d+/g); return m ? [+m[0], +m[1], +m[2]] : [0, 0, 0];
  }
  function toner(g, mode, s) {
    var bg = rgb(getComputedStyle(root).getPropertyValue('--bg'));
    if (g.pal) { var P = g.pal[mode]; return function (t, o) { t = 0.5 + (t - 0.5) * s; for (var k = 0; k < 3; k++) o[k] = P[0][k] + (P[1][k] - P[0][k]) * t; }; }
    if (mode === 'night') return function (t, o) { for (var k = 0; k < 3; k++) o[k] = Math.min(255, bg[k] + 112 * t * s); };
    if (g.invertDay) return function (t, o) { for (var k = 0; k < 3; k++) o[k] = Math.max(0, bg[k] - 94 * t * 0.9 * s); };
    return function (t, o) { for (var k = 0; k < 3; k++) { var lo = bg[k] - 34; o[k] = bg[k] + (Math.min(250, bg[k] + 30) - lo) * (t - 0.06) * s; } };
  }

  var cache = {};
  function lowres(key, mode, aspect, s) {
    var g = G[key], lw = g.lw, lh = Math.max(40, Math.round(lw / aspect)), id = [key, mode, lh, s, cfg.seed, tigerReady, inkReady].join('|');
    if (cache[id]) return cache[id];
    var f = g.field(lw, lh, cfg.seed), c = document.createElement('canvas'); c.width = lw; c.height = lh;
    var x = c.getContext('2d'), im = x.createImageData(lw, lh), tone = toner(g, mode, s), px = [0, 0, 0];
    for (var i = 0; i < lw * lh; i++) { tone(Math.min(1, Math.max(0, f[i])), px); im.data[i * 4] = px[0]; im.data[i * 4 + 1] = px[1]; im.data[i * 4 + 2] = px[2]; im.data[i * 4 + 3] = 255; }
    x.putImageData(im, 0, 0); cache[id] = c; return c;
  }
  var grainTile = null;
  function grain() {
    if (grainTile) return grainTile;
    var c = document.createElement('canvas'); c.width = c.height = 160; var x = c.getContext('2d'), d = x.createImageData(160, 160);
    for (var i = 0; i < d.data.length; i += 4) { var v = Math.random() < 0.5 ? 0 : 255; d.data[i] = d.data[i + 1] = d.data[i + 2] = v; d.data[i + 3] = (10 + Math.random() * 26) * cfg.grain * 1.4; }
    x.putImageData(d, 0, 0); return (grainTile = c);
  }
  function draw(canvas, key) {
    var r = canvas.getBoundingClientRect(); if (!r.width || !r.height) return;
    var dpr = Math.min(1.5, window.devicePixelRatio || 1), W = Math.round(r.width * dpr), H = Math.round(r.height * dpr);
    canvas.width = W; canvas.height = H;
    var x = canvas.getContext('2d'), mode = root.getAttribute('data-mode') === 'night' ? 'night' : 'day';
    var src = lowres(key, mode, W / H, cfg.strength);
    x.imageSmoothingEnabled = !G[key].pixel; x.imageSmoothingQuality = 'high'; x.drawImage(src, 0, 0, W, H);
    if (cfg.grain > 0) { x.fillStyle = x.createPattern(grain(), 'repeat'); x.fillRect(0, 0, W, H); }
  }
  function paint() {
    if (!G[cfg.style]) return;
    try {
      if (cfg.behind === 'fade') { draw(heroC, cfg.style); draw(fixedC, 'flat'); }
      else draw(fixedC, cfg.style);
    } catch (e) {
      // if a browser refuses to read the art, show the plain grain instead of nothing
      try { draw(fixedC, 'flat'); } catch (e2) {}
    }
  }

  /* ---------- lifecycle ---------- */
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 60); };
  if (document.readyState === 'complete') idle(paint); else window.addEventListener('load', function () { idle(paint); });
  document.addEventListener('nm:mode', paint);
  var lastW = window.innerWidth, lastH = window.innerHeight, rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      if (Math.abs(window.innerWidth - lastW) > 40 || Math.abs(window.innerHeight - lastH) > 160) { lastW = window.innerWidth; lastH = window.innerHeight; paint(); }
    }, 180);
  });
  if (cfg.drift && root.getAttribute('data-motion') !== 'off') {
    var st = document.createElement('style');
    st.textContent = '@keyframes nmdrift{from{transform:scale(1.06) translate(-1%,-1%)}to{transform:scale(1.06) translate(1%,1%)}}#NMBackground canvas{animation:nmdrift 70s ease-in-out infinite alternate}';
    document.head.appendChild(st);
  }
})();
